fx.urls({
    "www.flexilivre.test" : 
    {
        "https://www.flexilivre.com/app/instagram" : "https://www.flexilivre.dev/app/instagram",
        "/api/v1/auth/login" : "https://www.flexilivre.com/api/v1/auth/login",
    },
    "www.flexilivre.com" : 
    {
    },
    "www.flexilivre.dev" :
    {
        "https://jobs.flexilivre.com/upload-notify" : "https://jobs-dev.flexilivre.com/upload-notify",
        "https://jobs.flexilivre.com/editor-upload" : "https://jobs-dev.flexilivre.com/editor-upload",
        "https://jobs.flexilivre.com/convert-status" : "https://jobs-dev.flexilivre.com/convert-status",
        "https://jobs.flexilivre.com/customer/photos/zip" : "https://www.jobs.dev/customer/photos/zip"
    }
});
